import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router";
import { TextField, Button } from "@mui/material";
import {
  signupUser,
  clearState,
  authenticateUser,
} from "../features/User/UserSlice";
import { RootState } from "../app/store";
import "../styles/pages/register.scss";
import { navigationLinks } from "../utils/navigationLinks";
import NavbarScroller from "../components/Navbar";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import CustomButton from "../components/CustomButton";

const Register: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [userInput, setUserInput] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    username: "",
  });

  const {
    isFetching,
    isError,
    isRegistrationSuccess,
    errorMessage,
    email,
    isAuth,
  } = useSelector((state: RootState) => state.user);

  const onClickHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    dispatch(clearState());
    dispatch(signupUser(userInput));
  };

  // On first load, check if user is authenticated. If authenticated, redirect to Home Page
  // Check for updates in isRegistrationSuccess, isError, errorMessage
  // and redirect to Login page if isRegistrationSuccess.

  useEffect(() => {
    if (isError) {
      const errors = errorMessage[0] as any;

      if (typeof errors !== "string") {
        for (let i in errors) {
          toast.error(errors[i]);
        }
      } else if (errors === "Unauthorized") {
      } else {
        toast.error(errors);
      }
    }
  }, [isError, errorMessage]);

  useEffect(() => {
    if (isRegistrationSuccess) {
      toast.success("Registration successful!");
      dispatch(clearState());
      history.push("/login");
    }
  }, [isRegistrationSuccess]);

  useEffect(() => {
    //clear the state beforehand
    dispatch(clearState());
    dispatch(authenticateUser());
  }, []);

  useEffect(() => {
    if (isAuth) {
      history.push("/home");
    }
  }, [isAuth]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault();
      dispatch(clearState());
      dispatch(signupUser(userInput));
    }
  };

  return (
    <div>
      <NavbarScroller links={navigationLinks.links} />
      <div className="register-form">
        <form
          action="post"
          className="register-form--child"
          autoComplete="false"
          onKeyDown={(e) => handleKeyDown(e)}
        >
          <h1>Register</h1>
          <div className="name">
            <TextField
              label="Name"
              variant="outlined"
              onChange={(e) => {
                setUserInput((data) => ({ ...data, name: e.target.value }));
              }}
            />
          </div>
          <div className="username">
            <TextField
              label="Username"
              variant="outlined"
              onChange={(e) => {
                setUserInput((data) => ({ ...data, username: e.target.value }));
              }}
            />
          </div>
          <div className="email">
            <TextField
              label="Email"
              variant="outlined"
              onChange={(e) => {
                setUserInput((data) => ({ ...data, email: e.target.value }));
              }}
              type="email"
            />
          </div>
          <div className="password">
            <TextField
              label="Password"
              variant="outlined"
              onChange={(e) => {
                setUserInput((data) => ({ ...data, password: e.target.value }));
              }}
              type="password"
            />
          </div>

          <div className="confirm-password">
            <TextField
              label="Confirm Password"
              variant="outlined"
              onChange={(e) => {
                setUserInput((data) => ({
                  ...data,
                  confirmPassword: e.target.value,
                }));
              }}
              type="password"
            />
          </div>

          <CustomButton
            displayText="Register"
            onClick={(e) => {
              onClickHandler(e);
            }}
            className="register-button"
            style={{
              color: "black",
              border: "2px solid black",
              width: "12.5rem",
              boxShadow: "5px 5px 0",
            }}
          />
          <p>
            Already registered?
            <Link to="/login" id="login-link">
              Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
